import { deviceType } from '@/utils/common'

export const onboardingMixin = {
  data () {
    return {
      logoUrl: require('@/assets/image/onboarding/common/nestle-logo.png'),
      languageOptions: [{ id: 'zh', text: '简体中文' }, { id: 'en', text: 'English' }, { id: 'hk', text: '繁體中文' }],
      fixStyle: '',
      messages: []
    }
  },
  computed: {
    invitationId () {
      return this.$route.params.invitationId
    },
    menuOptions () {
      return [
        { text: this.$t('onboarding.nestle.completeMyPaperwork'), link: this.invitationId ? `/onboarding/${this.invitationId}/nestle/paperwork-home` : '' },
        { text: this.$t('onboarding.nestle.myFirstDay'), link: this.invitationId ? `/onboarding/${this.invitationId}/nestle/my-first-day` : '' },
        { text: this.$t('onboarding.nestle.learning'), link: this.invitationId ? `/onboarding/${this.invitationId}/nestle/learning` : '' }
      ]
    },
    isRequiredMessage () {
      return (this.isRequired === 'true' || this.isRequired === true) ? this.$t('onboarding.nestle.error.isRequired') : this.isRequired
    },
    isEn () {
      return this.$i18n.locale === 'en'
    }
  },
  created () {
    const isNestle = this.$parent.isNestle
    if (isNestle) {
      const isMobile = deviceType.isMobile
      this.logoUrl = require(isMobile ? '@/assets/image/onboarding/common/nestle-logo.png' : '@/assets/image/onboarding/common/nestle-gray-logo.jpg')
    } else {
      this.logoUrl = this.$parent.logoPath
    }
  },
  mounted () {},
  methods: {
    toVuePage (path, openNewWindow) {
      if (openNewWindow) {
        const newPath = this.$router.resolve(path)
        window.open(newPath.href, '_blank')
      } else {
        this.$router.push(path)
      }
    },
    toOutSide (path, openInCurrentWindow) {
      if (openInCurrentWindow) {
        window.location.href = path
      } else {
        window.open(path, '_blank')
      }
    },
    fieldIsRequired (value) {
      return value !== false && value !== 'false'
    },
    getText (text) {
      let key = this.$i18n.locale
      if (key === 'hk') {
        key = 'tc'
      }
      if (key === 'zh') {
        key = 'cn'
      }
      if (text && text[key]) {
        return text[key]
      }
      return ''
    },
    getOptions (options) {
      const result = []
      const getText = this.getText
      for (const option of options) {
        if (option) {
          result.push({
            id: option.id,
            get text () {
              return getText(option.text)
            }
          })
        }
      }
      return result
    },
    sortSteps (steps) {
      if (!(steps instanceof Array)) {
        return
      }
      return steps.sort((a, b) => { return a.order < b.order ? -1 : 1 })
    },
    addFileModelForInput (stepQuestionList) {
      for (let index = 0; index < stepQuestionList; index++) {
        const question = stepQuestionList[index]
        if (question.type === 'ATTACHMENT') {
          stepQuestionList[index].file = ''
          stepQuestionList[index].uploadFunc = ''
        }
      }
      return stepQuestionList
    },
    showMessage (text, type, delay = 3) {
      this.messages.push({
        text: text,
        type: type,
        delay: delay
      })
    }
  }
}
